import TodoFolderView from '../store/schema/TodoFolderView';
import { orchestrator } from 'satcheljs';
import { taskFromEmailCreated } from '../actions/dropActions';
import { todoUpdated } from '../actions/todoActions';
import { todosAdded } from '../actions/todoFolderViewActions';
import { reloadItems } from './reloadItems';

orchestrator(taskFromEmailCreated, () => {
    reloadItems();
});

export const todoUpdatedOrchestrator = orchestrator(todoUpdated, actionMessage => {
    const { isSuccessful } = actionMessage;
    if (!isSuccessful) {
        reloadItems();
    }
});

orchestrator(todosAdded, () => {
    reloadItems();
});

export { TodoFolderView };
